import { useMe, usePopUpMessage } from '@hb/react'
import { AssessmentDocument, ConsentForm, FieldMapValue, isConsentForm, WithId } from '@hb/shared'
import { useCallback, useMemo, useState } from 'react'
import { signConsentForm } from '../backend/consentForms/utils'

export const useSignConsentForm = (
  document: WithId<ConsentForm> | WithId<AssessmentDocument> | null,
  onSignSuccess?: () => void,
  adminView?: boolean,
) => {
  const { processResponse } = usePopUpMessage()
  const [isSigning, setIsSigning] = useState(false)
  const me = useMe()
  const handleSignConsentForm = useCallback(
    async (formData: FieldMapValue) => {
      if (!document) return processResponse({ error: 'No document selected' })
      if (document.type !== 'consentForm')
        return processResponse({ error: 'Invalid document type' })
      try {
        setIsSigning(true)
        await signConsentForm({ consentFormId: document.id, formData })
      } catch (err: any) {
        console.error(err)
        return processResponse({
          error: err?.message || 'Error signing consent form',
        })
      }
      setIsSigning(false)
      if (onSignSuccess) onSignSuccess()
      return processResponse({ success: 'Consent form signed successfully' })
    },
    [processResponse, document, onSignSuccess],
  )

  const onSignConsentForm = useMemo(
    () =>
      me &&
      document &&
      isConsentForm(document) &&
      !document.signedBy &&
      me.uid === document.toBeSignedByUser
        ? handleSignConsentForm
        : undefined,
    [me, document, handleSignConsentForm],
  )
  const canDownload = useMemo(
    // () => !!(document && isConsentForm(document) && document.signedOn),
    () => {
      if (!document) return false
      if (!isConsentForm(document)) return false
      if (document.signedOn) return true
      if (adminView) return true
      return false
    },
    [document, adminView],
  )
  return { isSigning, onSignConsentForm, canDownload }
}
